import React from 'react'

import Grid from '@material-ui/core/Grid'
import {FlagIcon} from "react-flag-kit";
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'

import Select from 'Components/Select'

const FlagAvailable = ["AD","AE","AF","AG","AI","AL","AM","AO","AR","AS","AT","AU","AW","AX","AZ","BA","BB","BD","BE","BF","BG","BH","BI","BJ","BL","BM","BN","BO","BR","BS","BT","BV","BW","BY","BZ","CA","CC","CD","CF","CG","CH","CI","CK","CL","CM","CN","CO","CR","CU","CV","CW","CX","CY","CZ","DE","DJ","DK","DM","DO","DZ","EC","EE","EG","ER","ES","ET","EU","FI","FJ","FK","FM","FO","FR","GA","GB","GB-ENG","GB-NIR","GB-SCT","GB-WLS","GB-ZET","GD","GE","GF","GG","GH","GI","GL","GM","GN","GP","GQ","GR","GS","GT","GU","GW","GY","HK","HM","HN","HR","HT","HU","ID","IE","IL","IM","IN","IO","IQ","IR","IS","IT","JE","JM","JO","JP","KE","KG","KH","KI","KM","KN","KP","KR","KW","KY","KZ","LA","LB","LC","LGBT","LI","LK","LR","LS","LT","LU","LV","LY","MA","MC","MD","ME","MG","MH","MK","ML","MM","MN","MO","MP","MQ","MR","MS","MT","MU","MV","MW","MX","MY","MZ","NA","NC","NE","NF","NG","NI","NL","NO","NP","NR","NU","NZ","OM","PA","PE","PF","PG","PH","PK","PL","PM","PN","PR","PS","PT","PW","PY","QA","RE","RO","RS","RU","RW","SA","SAMI","SB","SC","SD","SE","SE-JAM","SE-SKA","SE-VAS","SEFI","SG","SI","SJ","SK","SL","SM","SN","SO","SR","SS","ST","SV","SX","SY","SZ","TC","TD","TF","TG","TH","TJ","TK","TL","TM","TN","TO","TORN","TR","TT","TV","TW","TZ","UA","UG","UM","US","US-CA","UY","UZ","VA","VC","VE","VG","VI","VN","VU","WF","WS","WW","WW-AFR","WW-ASI","WW-AUS","WW-EUR","WW-NAM","WW-SAM","XK","YE","YT","ZA","ZM","ZW"]


export default class PaysNationaliteLangue extends React.Component {
  constructor (props) {
    super(props)
  }
  restate = () => {
    this.setState({
      datas: Data.list(Constants.module.COMMUN, Constants.donnee.pays)
    })
  }

  handleContactStateChange = (val) => {
    this.props.onChange(val, this.props.name)
  }

  render () {
    if (this.props.object === 'pays' || this.props.object === 'nationalite') {
      Data.addCbRestate(Constants.module.COMMUN, Constants.donnee.pays, this.restate)
      const listPays = Data.list(Constants.module.COMMUN, Constants.donnee.pays)
      return (
        <Grid container spacing={0} style={{margin: 0, padding: 0}} direction="column" justify="center"
              alignItems="stretch">
          {
            <Select
              inline={this.props.inline}
              title={this.props.object === 'pays' ? "Pays" : "Nationalité"}
              disabled={this.props.disabled || false}
              onChange={this.handleContactStateChange}
              name="entite"
              //autoComplete={false}
              options={listPays.filter(pays => FlagAvailable.indexOf(pays.code_alpha2) > -1 && (this.props.object === 'pays' || (pays.nationalite !== ''))).map(pays => ({
                label: this.props.object === 'pays' ? pays.libelle : pays.nationalite,
                value: pays.id,
                startAdornment: <FlagIcon style={{paddingLeft: 5}} code={pays.code_alpha2} size={20}/>
              }))}
              value={this.props.data}/>
          }
        </Grid>
      )
    } else {
      Data.addCbRestate(Constants.module.COMMUN, Constants.donnee.langue, this.restate)
      const listLangues = Data.list(Constants.module.COMMUN, Constants.donnee.langue)
      return (
        <Grid container spacing={0} style={{margin: 0, padding: 0}} direction="column" justify="center"
              alignItems="stretch">
          {
            <Select
              inline={this.props.inline}
              title="Langue Parlée"
              disabled={this.props.disabled || false}
              onChange={this.handleContactStateChange}
              name="entite"
              options={listLangues.filter(lang => FlagAvailable.indexOf(lang.code_alpha2.toUpperCase()) > -1).map(lang => ({
                label: lang.libelle,
                value: lang.id,
                startAdornment: <FlagIcon style={{paddingLeft: 5}} code={lang.code_alpha2.toUpperCase()} size={20}/>
              }))}
              value={this.props.data}/>}
        </Grid>
      )
    }
  }
}




// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/Other/PaysNationaliteLangue.js